<script setup lang="ts">
import type { NewsItemProps } from '@/types/appTypes'

const props = withDefaults(defineProps<NewsItemProps>(), {})

const app = useNuxtApp()
</script>

<template>
  <div class="c-newsItem">
    <v-divider />
    <div class="c-newsItem">
      <div class="c-newsItem_content">
        <div class="c-newsItem_content_text">
          <nuxt-link
            v-bind:to="`/news/${item.article_slug}`"
          >
            {{ item.title }}
          </nuxt-link>
          <div
            v-if="item && item.open_date"
            class="c-newsItem_content_text_date"
          >
            （掲載日時:{{ app.$getPeriodDayLabelNoDD(item.open_date) }}）
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang = "scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-newsItem {
  width: 100%;
  margin: 12px -12px 12px 0;
  font-family: var(--g_font_family_NotoSansCJKjp);

  @include responsive.mq_down(sp) {
    margin: 12px 12px 12px 0;
  }

  &_content {
    display: flex;

    &::before {
      content: "\276F ";
      margin-right: 10px;
      color: var(--color_primary_link);
      font-size: 18px;
    }

    &_text {
      color: var(--color_primary_link);
      font-size: 16px;
      font-weight: bold;
      line-height: 1.7;

      &_date {
        color: var(--g_color_text_888888);
        font-size: 14px;
        font-weight: 500;
        line-height: 2.286;
      }

      a {
        color: var(--color_primary_link);
        font-weight: bold;
      }
    }
  }
}
</style>
